import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Image, Button } from 'semantic-ui-react';

import '../Common.css';

export const Dialog = ({
  image,
  title,
  body,
  buttonStyle,
  buttonText,
  buttonOnClick,
  onClose,
}) => (
  <Modal centered open size="mini" closeIcon onClose={onClose}>
    <Modal.Content>
      <div className="common-modal-root">
        <Image className="common-modal-image" src={image} />
        <p className="common-modal-title">{title}</p>
        <p className="common-modal-body">{body}</p>
        <Button className={buttonStyle} onClick={buttonOnClick}>
          {buttonText}
        </Button>
      </div>
    </Modal.Content>
  </Modal>
);

Dialog.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  buttonStyle: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/dialog/Dialog.js